__turbopack_context__.v({
  "crossButton": "ModalHeader-module__ATjliq__crossButton",
  "dark": "ModalHeader-module__ATjliq__dark",
  "header": "ModalHeader-module__ATjliq__header",
  "rightButton": "ModalHeader-module__ATjliq__rightButton",
  "title": "ModalHeader-module__ATjliq__title",
});
